module.exports = __webpack_public_path__ + "static/priviliges-4-c24133d752a1d764a79b93cff4f5c6dc.png";